import Tag from './shared/Tag';

export default class RawMustacheTag extends Tag {
	type: 'RawMustacheTag'
}
